import { render, staticRenderFns } from "./FondoCustom.vue?vue&type=template&id=99d8ea56&scoped=true&"
import script from "./FondoCustom.vue?vue&type=script&lang=js&"
export * from "./FondoCustom.vue?vue&type=script&lang=js&"
import style0 from "./FondoCustom.vue?vue&type=style&index=0&id=99d8ea56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d8ea56",
  null
  
)

export default component.exports